import React from 'react';

export const textToKey = (text: string) => text.replace(/ /g, '_');

export const wrapInText =
    (...wrapFns: Array<(part: string) => React.ReactNode>) =>
    (text: string) => {
        let currentIdx = 0;
        const result: React.ReactNode[] = [];
        let iteration = 0;
        // eslint-disable-next-line no-constant-condition
        while (true) {
            const openIdx = text.indexOf('[', currentIdx);
            const closeIdx = text.indexOf(']', openIdx);
            if (openIdx === -1 || closeIdx === -1) {
                break;
            }
            result.push(
                <React.Fragment key={'text-' + iteration}>{text.substring(currentIdx, openIdx)}</React.Fragment>,
                <React.Fragment key={'wrap-' + iteration}>
                    {wrapFns[iteration](text.substring(openIdx + 1, closeIdx))}
                </React.Fragment>,
            );
            currentIdx = closeIdx + 1;
            iteration++;
        }
        result.push(<React.Fragment key="text-closing">{text.substring(currentIdx)}</React.Fragment>);
        return <>{result}</>;
    };
